var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#0095DA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9998,
    cy: 14,
    r: 12.1739,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_8656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4087 14C3.4087 19.8494 8.15064 24.5913 14 24.5913C19.8494 24.5913 24.5913 19.8494 24.5913 14C24.5913 8.15063 19.8494 3.40869 14 3.40869C8.15064 3.40869 3.4087 8.15063 3.4087 14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.96509 11.8087L5.23465 8.15649L3.77378 11.4435L3.40857 14.7304L5.96509 11.8087Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0348 11.8087L22.7652 8.15649L24.2261 11.4435L24.5913 14.7304L22.0348 11.8087Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7651 19.8435L18.7477 20.5739L16.5564 24.2261L20.2086 22.7652L22.7651 19.8435Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.23466 19.8435L9.25205 20.5739L11.4434 24.2261L7.79118 22.7652L5.23466 19.8435Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0173 4.13911L13.9999 5.9652L9.98255 4.13911L13.9999 3.04346L18.0173 4.13911Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6521 13.2695L13.9999 10.3478L10.3478 13.2695L11.4434 17.6521H16.5564L17.6521 13.2695Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3.04346C20.0511 3.04346 24.9565 7.94893 24.9565 14C24.9565 20.051 20.0511 24.9565 14 24.9565C7.94897 24.9565 3.0435 20.051 3.0435 14C3.05027 7.95178 7.95182 3.05023 14 3.04346ZM5.51496 8.29899L6.27428 11.5267L10.2747 12.8601L13.6348 10.1725V6.21236L9.80002 4.67855C8.06381 5.46516 6.58047 6.71846 5.51496 8.29899ZM5.45397 19.6043L9.07583 20.1762L11.048 17.571L10.0433 13.5536L6.08721 12.2352L3.82101 14.9546C3.97544 16.615 4.53629 18.2119 5.45397 19.6043ZM18.9082 20.1787L22.5461 19.6043C23.4638 18.2116 24.0244 16.6143 24.1787 14.9535L21.9143 12.2342L17.9582 13.5526L16.9535 17.5721L18.9082 20.1787ZM24.2229 13.8637C24.2035 12.2345 23.7924 10.6337 23.0245 9.19669L22.4321 11.7167L24.2229 13.8637ZM16.2714 17.2869L17.2403 13.4076L14 10.8156L10.7591 13.4086L11.7286 17.2869H16.2714ZM5.56792 11.7152L4.97551 9.19527C4.20763 10.6322 3.79658 12.2329 3.77714 13.8623L5.56792 11.7152ZM10.796 4.29069L14 5.57216L17.2212 4.29657C15.1362 3.60163 12.8823 3.59966 10.796 4.29069ZM18.2175 4.68694L14.3652 6.21361V10.1725L17.7253 12.8601L21.7258 11.5267L22.4851 8.29899C21.4231 6.72416 19.9462 5.47408 18.2175 4.68694ZM21.9358 20.4401L18.967 20.9092L17.1716 23.7214C19.0416 23.1072 20.6954 21.9682 21.9358 20.4401ZM16.1245 24.0026L18.3038 20.5907L16.3739 18.0174H11.6261L9.66859 20.6031L11.5676 23.9313C13.0615 24.2992 14.6192 24.3241 16.1241 24.0044L16.1245 24.0026ZM10.5531 23.6267L8.99647 20.9026L6.06278 20.4398C7.24136 21.8912 8.79407 22.9931 10.5531 23.6267Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_8656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.913,
    height: 21.913,
    fill: "white",
    transform: "matrix(-1 0 0 1 24.9565 3.04346)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.654573b66b6b2570c87d74ecfe561c0e.svg";
export { ForwardRef as ReactComponent };